module.exports = __webpack_public_path__ + "static/media/pequeno_prazer_7.2bbe4036.jpg";